const somardesjejum = () => {
  const total = document.querySelector("#qtde_desjejum");
  const pao = document.querySelector("#qtde_pao");
  const minipao = document.querySelector("#qtde_minipao");

  if (pao) {
    pao.addEventListener("change", (e) => {
      if (minipao && parseInt(minipao.value) > 0)
        total.value = parseInt(minipao.value) + parseInt(pao.value);
      else total.value = parseInt(pao.value);
    });
  }

  if (minipao) {
    minipao.addEventListener("change", (e) => {
      if (pao && parseInt(pao.value) > 0)
        total.value = parseInt(pao.value) + parseInt(minipao.value);
      else total.value = parseInt(minipao.value);
    });
  }
};

export default somardesjejum;
